import React, { useState } from 'react';
import { StyleSheet, TextInput, TouchableOpacity, View } from 'react-native';

import { Color, CommonProperties, CommonStyles } from '../styles';
import FormLabel from './FormLabel';
import FormError from './FormError';
import Icon from './Icon';
import { scale } from '../utils/scale.utils';

const InputForm = ({
  label,
  required,
  smallText,
  errorMessage,
  secure,
  style,
  onChangeText,
  styleContainer,
  rightIcon,
  rightIconContainerStyle,
  width,
  ...inputProps
}) => {
  const [showPass, setShowPass] = useState(false);

  return (
    <View style={[CommonStyles.mb2, styleContainer]}>
      {!!label && <FormLabel label={label} required={required} smallText={smallText} />}
      <View>
        <TextInput
          style={[
            styles.textInput,
            width && { width: scale(width) },
            {
              borderColor: errorMessage ? Color.required : Color.gray,
              backgroundColor:
                inputProps.editable !== undefined && !inputProps.editable
                  ? Color.white
                  : Color.transparent,
              color:
                inputProps.editable !== undefined && !inputProps.editable
                  ? Color.text.low
                  : Color.text.high,
              paddingRight: secure ? scale(36) : 0,
            },
            style,
          ]}
          onChangeText={(text) => {
            onChangeText(text);
          }}
          secureTextEntry={secure && !showPass}
          {...inputProps}
        />
        {rightIcon && (
          <View style={StyleSheet.flatten([styles.icon, rightIconContainerStyle])}>
            {rightIcon}
          </View>
        )}
        {secure && (
          <TouchableOpacity
            style={styles.icon}
            onPress={() => {
              setShowPass(!showPass);
            }}
          >
            <Icon size={24} name={showPass ? 'eyeSlash' : 'eye'} color={Color.text.high} />
          </TouchableOpacity>
        )}
      </View>
      {!!errorMessage && <FormError errorMessage={errorMessage} />}
    </View>
  );
};

const styles = StyleSheet.create({
  textInput: {
    borderWidth: 0.5,
    height: scale(36),
    ...CommonProperties.body,
    ...CommonProperties.fontFamily,
    ...CommonProperties.px2,
    ...CommonProperties.my2,
    ...CommonProperties.borderRadius,
  },
  icon: {
    width: scale(36),
    position: 'absolute',
    right: 0,
    top: 0,
    bottom: 0,
    ...CommonProperties.myauto,
    ...CommonProperties.centerAlignment,
  },
});

export default InputForm;
